export default {
	key: 'layout',
	path: '/layout',
	name: 'layout',
	component: () => import(/* webpackChunkName: "layout" */ '@/modules/documentation/pages/layout/index.vue'),
	children: [
		{
			key: 'layout-boxes',
			path: 'boxes',
			name: 'boxes',
			component: () => import(/* webpackChunkName: "boxes" */ '@/modules/documentation/pages/layout/boxes.vue')
		},
		{
			key: 'layout-grid',
			path: 'grid',
			name: 'grid',
			component: () => import(/* webpackChunkName: "grid" */ '@/modules/documentation/pages/layout/grid.vue')
		}
	]
};
